import t from "./index59.mjs";
import f from "./index61.mjs";
function i(o) {
  var r = f(o, "string");
  return t(r) == "symbol" ? r : r + "";
}
export {
  i as default
};
